import React, { useState } from "react";
import { Table, Select, Button, Input } from "antd";
import styles from "./CustomerManagement.module.css";
import { useNavigate } from "react-router-dom";
import actionicon from "../../../../assets/images/actionicon.svg";
import {
  Dropdown,
  Modal,
  SubmitButton,
  TextComponent,
} from "../../../../components";
import HeaderComponent from "../../../../components/HeaderComponent/HeaderComponent";
import { ReactComponent as ViewIcon } from "../../../../assets/images/view.svg";
import { ReactComponent as ArchiveIcon } from "../../../../assets/images/archive.svg";
import { ReactComponent as EditIcon } from "../../../../assets/images/editIcon.svg";

const { Option } = Select;

const CustomerManagement = () => {
  const navigate = useNavigate();
  const [isModal, setIsModal] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
 
  const [statuss, setStatus] = useState({
    value: "Active",
    id: 1,
  });

  const handleDisplayFilter = () => {
    setShowFilter(true);
  };

  const columns = [
    {
      title: "No",
      dataIndex: "No",
      key: "No",
    },
    {
      title: "Customer Name",
      dataIndex: "CustomerName",
      key: "CustomerName",
    },
    {
      title: "Contact Info",
      key: "ContactInfo",
      dataIndex: "ContactInfo",
    },
    {
      title: "Total Orders",
      dataIndex: "TotalOrder",
      key: "TotalOrder",
    },
    {
      title: "Last Order Date",
      key: "OrderDate",
      dataIndex: "OrderDate",
    },
    {
      title: "Action",
      key: "Action",
      dataIndex: "Action",
      render: (text) => (
        <div className={styles.itemsButtonDiv}>
          <ViewIcon
            className={styles.itemsButton}
            onClick={() =>
              navigate("/AdminCustomerManagement/CustomerManagementDetails")
            }
          />
          <EditIcon
            className={styles.itemsButton}
            onClick={() =>
              navigate("/AdminCustomerManagement/AdminEditCustomer")
            }
          />
          <ArchiveIcon
            className={styles.itemsButton}
            onClick={() => setIsModal(true)}
          />
        </div>
      ),
    },
  ];

  const data = [
    {
      No: "1",
      CustomerName: "John Doe",
      ContactInfo: "(214) 390-8650",
      TotalOrder: "05",
      OrderDate: "Jul 23, 2025",
    },
    {
      No: "2",
      CustomerName: "Sarah Williams",
      ContactInfo: "(305) 442-9932",
      TotalOrder: "03",
      OrderDate: "Aug 02, 2025",
    },
    {
      No: "3",
      CustomerName: "Michael Johnson",
      ContactInfo: "(509) 687-1149",
      TotalOrder: "08",
      OrderDate: "Jun 15, 2025",
    },
    {
      No: "4",
      CustomerName: "Emily Davis",
      ContactInfo: "(702) 331-2204",
      TotalOrder: "02",
      OrderDate: "Sep 10, 2025",
    },
    {
      No: "5",
      CustomerName: "Robert Brown",
      ContactInfo: "(415) 870-6653",
      TotalOrder: "06",
      OrderDate: "May 28, 2025",
    },
    {
      No: "6",
      CustomerName: "Jessica Miller",
      ContactInfo: "(646) 553-7810",
      TotalOrder: "09",
      OrderDate: "Jul 04, 2025",
    },
    {
      No: "7",
      CustomerName: "David Wilson",
      ContactInfo: "(312) 770-4489",
      TotalOrder: "04",
      OrderDate: "Oct 18, 2025",
    },
    {
      No: "8",
      CustomerName: "Sophia Anderson",
      ContactInfo: "(213) 942-1173",
      TotalOrder: "07",
      OrderDate: "Aug 29, 2025",
    },
    {
      No: "9",
      CustomerName: "James Martinez",
      ContactInfo: "(917) 335-9420",
      TotalOrder: "01",
      OrderDate: "Nov 05, 2025",
    },
    {
      No: "10",
      CustomerName: "Olivia Taylor",
      ContactInfo: "(512) 603-7791",
      TotalOrder: "10",
      OrderDate: "Jun 09, 2025",
    },
  ];

  return (
    <div className={styles.mainCont}>
      <HeaderComponent
        heading={"Customer Management"}
        showFilterIcon={true}
        onClickFilter={() => handleDisplayFilter()}
        onSearch={(e) => console.log(e.target.value)}
        onSubmit={() => navigate("/AdminCustomerManagement/AdminAddCustomer")}
        submitButtonText={"Add Customer"}
        // showBackIcon={true}
         showSubmitButton={true}
        showSearch={true}
      />

      <div className={styles.subCont}>
        <div className={styles.TableDiv}>
          <Table
            scroll={{ x: true }}
            columns={columns}
            dataSource={data}
            pagination={false}
            rowKey="No"
          />
        </div>
      </div>
      <Modal
        open={isModal}
        onClickOkButton={() => {
          setIsModal(false);
        }}
        onCancel={() => setIsModal(false)}
        className={styles.modalCont}
        title={"Archive"}
        headingClass={styles.modalHeading}
        width={"400px"}
        onClickCancelButton={() => setIsModal(false)}
        okBtnTitle={"Yes"}
        twoButton
        cancelBtnTitle={"No"}
        btnStyle={{ width: "200px", marginTop: "12px" }}
        onBtnPress={() => setIsModal(false)}
      >
        <div>
          <TextComponent
            text="Are you sure you want to archive? "
            className={styles.CardText}
          />
        </div>
      </Modal>

      {/* filter modal  */}

      <Modal
        open={showFilter}
        onClickOkButton={() => {
          setShowFilter(false);
        }}
        onCancel={() => setShowFilter(false)}
        className={styles.modalCont}
        title={"Filters"}
        headingClass={styles.modalHeading}
        width={"400px"}
        btnStyle={{ width: "200px", marginTop: "12px" }}
        twoButton
        onBtnPress={() => setShowFilter(false)}
        onClickCancelButton={() => setShowFilter(false)}
        okBtnTitle={"Apply Filters"}
        cancelBtnTitle={"Reset All"}
      >
        <Dropdown
          className={styles.input}
          label={"Status"}
          labelClass={styles.labelClass}
          value={statuss}
          style={{ color: "var(--black-color)" }}
          options={[
            {
              value: "Active",
              id: 1,
            },
            {
              value: "Archived",
              id: 2,
            },
          ]}
          onChange={(e) => setStatus(e)}
        />
      </Modal>
    </div>
  );
};

export default CustomerManagement;
